export interface CurrencyOption {
  code: string;
  name: string;
}

const CODE = /^[A-Z]{3}$/;

let cached: readonly CurrencyOption[] | null = null;

/** ISO 4217 codes this browser knows with their English names, sorted by code; computed once. */
export function supportedCurrencies(): readonly CurrencyOption[] {
  if (cached) return cached;
  const names = new Intl.DisplayNames(['en'], { type: 'currency' });
  cached = Intl.supportedValuesOf('currency')
    .filter((code) => CODE.test(code))
    .map((code) => ({ code, name: names.of(code) ?? code }))
    .sort((a, b) => a.code.localeCompare(b.code));
  return cached;
}

export function isCurrencyCode(value: string): boolean {
  return CODE.test(value) && supportedCurrencies().some((c) => c.code === value);
}

export function currencyName(code: string): string {
  return supportedCurrencies().find((c) => c.code === code)?.name ?? code;
}
